import { CLIENTS } from '@/components/admin/AdminOrders/graphql';
import { useQuery } from '@apollo/client';
import { captureException } from '@sentry/react';
import { useMemo } from 'react';

const useShippersAndCarriers = (test, shipperIds, carrierIds) => {
    const { loading, data } = useQuery(CLIENTS, {
        variables: {
            test: test
                ? { test_acc: { _eq: true } }
                : { _or: [{ test_acc: { _eq: false } }, { test_acc: { _is_null: true } }] },
            shipperFilter: shipperIds ? { client_id: { _in: shipperIds } } : {},
            carrierFilter: carrierIds ? { client_id: { _in: carrierIds } } : {},
        },
        onError: (e) => {
            console.error(e);
        },
    });

    return useMemo(() => {
        return [data?.shippers || [], data?.carriers || [], data?.mm_carriers || []];
    }, [data]);
};

export default useShippersAndCarriers;
